import deleteProject from './delete-project';
import getProjectCategories from './get-project-categories';
import getProjectDetails from './get-project-details';
import type { ProjectService } from './types';
import {
	updateProjectDetails as updateAllProjectDetails,
	updateProjectDetailsSimplified as updateAllProjectDetailsSimplified,
} from './update-all-project-details';
import updateProjectDetailsSimplified, { updateProjectDetails } from './update-project-details';
import updateProjectTeamTypeDetails from './update-project-team-type-details';

/**
 * Service to manage JIRA's project details
 */
const ProjectServiceImpl: ProjectService = {
	getProjectDetails,
	updateProjectDetailsSimplified,
	updateProjectDetails,
	updateProjectTeamTypeDetails,
	updateAllProjectDetails,
	updateAllProjectDetailsSimplified,
	deleteProject,
	getProjectCategories,
};

export default ProjectServiceImpl;
